<template>
<div class="sub-menu-content white">
  <div class="row no-margin-bottom">
    <h6 class="col s9">Presets</h6>
  </div>

  <div class="row no-margin-bottom">
    <div class="input-field col s12">
    <select v-model="selectedPreset">
        <option v-bind:value="0">{{$t('views.dashboard.selector.presetdefault')}}</option>
        <option v-for="preset in dashboardPresets" v-bind:value="preset" :key="preset.Id">
          {{ preset.Description }}
        </option>
      </select>
    </div>
  </div>

  <div class="row no-margin-bottom">
    <h6 class="col s9">Operational Status</h6>
    <h6 class="col s1">
      <label>
        <input type="checkbox" class="filled-in" v-model="statusSelector.operationModeStatus.normal" />
        <span class="green-text"></span>
      </label>
    </h6>
    <h6 class="col s1">
      <label>
        <input type="checkbox" class="filled-in" v-model="statusSelector.operationModeStatus.maintenance" />
        <span class="blue-text"></span>
      </label>
    </h6>
  </div>
  <div class="row no-margin-bottom">
    <h6 class="col s7">Monitor Status</h6>
    <h6 class="col s1">
      <label>
        <input type="checkbox" class="filled-in" v-model="statusSelector.monitorStatus.unknown" />
        <span class="grey-text"></span>
      </label>
    </h6>

    <h6 class="col s1">
      <label>
        <input type="checkbox" class="filled-in" v-model="statusSelector.monitorStatus.normal" />
        <span class="green-text"></span>
      </label>
    </h6>

    <h6 class="col s1">
      <label>
        <input type="checkbox" class="filled-in" v-model="statusSelector.monitorStatus.warning" />
        <span class="orange-text"></span>
      </label>
    </h6>

    <h6 class="col s1">
      <label>
        <input type="checkbox" class="filled-in" v-model="statusSelector.monitorStatus.error" />
        <span class="red-text"></span>
      </label>
    </h6>
  </div>

  <div class="row no-margin-bottom">
    <h6>RailOBject Types</h6>
    <section id="dropdown-2">
      <dropdown :data="possObjectCodes" multiple :width="310" :cbItemChanged="changed2"></dropdown>
    </section>
  </div>

  <div class="row no-margin-bottom">
    <h6>Regions</h6>
    <section id="dropdown-2">
      <dropdown :data="regions" multiple :width="310" :cbItemChanged="changed2"></dropdown>
    </section>
  </div>

  <div class="row no-margin-bottom">
    <h6>Contract Gebieden</h6>
    <section id="dropdown-2">
      <dropdown :data="departments" multiple :width="310" :cbItemChanged="changed2"></dropdown>
    </section>
  </div>

  <div class="row no-margin-bottom">
    <h6>Relaishuizen</h6>
    <section id="dropdown-2">
      <dropdown :data="complexes" multiple :width="310" :cbItemChanged="changed2"></dropdown>
    </section>
  </div>

  <!-- <v-layout row wrap>
    <v-flex xs12 sm12>
      <v-select
        label="RailObject Types"
        :items="possObjectCodes"
        v-model="selected.possObjectCodes"
        item-text="ObjectDescription"
        item-value="Id"
        multiple
        v-once
      ></v-select>
    </v-flex>
  </v-layout>

  <v-layout row wrap>
    <v-flex xs12 sm12>
      <v-select
        label="Regions"
        :items="regions"
        v-model="selected.regions"
        item-text="Name"
        item-value="RegionId"
        multiple
        v-once
      ></v-select>
    </v-flex>
  </v-layout>

  <v-layout row wrap>
    <v-flex xs12 sm12>
      <v-select
        label="Contract Gebieden"
        :items="departments"
        v-model="selected.departments"
        item-text="Name"
        item-value="DepartmentId"
        multiple
        v-once
      ></v-select>
    </v-flex>
  </v-layout>

  <v-layout row wrap>
    <v-flex xs12 sm12>
      <v-select
        label="Relaishuizen"
        :items="complexes"
        v-model="selected.complexes"
        item-text="Name"
        item-value="ComplexId"
        multiple
        v-once
      ></v-select>
    </v-flex>
  </v-layout> -->

  <!-- <v-layout row wrap>
    <v-flex xs12 sm12>
      <v-select
        label="RailObjecten"
        :items="railObjects"
        item-text="Name"
        item-value="RailObjectId"
        multiple
        autocomplete
      ></v-select>
    </v-flex>
  </v-layout> -->

  <div class="row">
    <h6>RailObjecten</h6>
    <virtual-list :size="30" :remain="10">
      <div class="railobject-item" v-for="railObject in railObjects" :key="railObject.RailObjectId">
        <label class="col s12">
          <input type="checkbox" class="filled-in" v-model="selectedRailObjects[railObject.RailObjectId]" />
          <span v-bind:class="railObjectColor(railObject) + '-text'">{{railObject.Name}}</span>
        </label>
      </div>
    </virtual-list>
  </div>

  <!-- <v-container
    style="max-height: 300px"
    class="scroll-y"
    id="scroll-target"
  >
    <v-layout
      column
      align-center
      justify-center
    >
      <v-flex xs12 sm12>
        <v-list>
          <v-list-tile avatar v-for="railObject in testRailObjects" :key="railObject.RailObjectId">
            <v-list-tile-content>
              <v-list-tile-title v-html="railObject.Name"></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-checkbox v-bind:color="railObjectColor(railObject)" v-model="selectedRailObjects[railObject.RailObjectId]"></v-checkbox>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    </v-container> -->
</div>
</template>

<script>
import RailObjectService from '../services/RailObjectService'
import DepartmentService from '../services/DepartmentService'
import RegionService from '../services/RegionService'
import ComplexService from '../services/ComplexService'
import PossObjectCodeService from '../services/PossObjectCodeService'
import DashboardPresetService from '../services/DashboardPresetService'
import UtilitiesService from '../services/UtilitiesService'
import virtualList from 'vue-virtual-scroll-list'

var subscribers = []
var filteredRailObjects = []
var railObjectsByOperationModeId = {}
var railObjectsByMonitorStatusId = {}
var railObjectsById = {}

export default {
  name: 'sub-menu-content',
  components: { 'virtual-list': virtualList },
  data () {
    return {
      railObjects: [],
      regions: [],
      departments: [],
      complexes: [],
      possObjectCodes: [],
      dashboardPresets: [],
      statusSelector: {
        mapClustered: false,
        monitorStatus: {
          unknown: true,
          normal: true,
          warning: true,
          error: true
        },
        operationModeStatus: {
          normal: true,
          maintenance: true
        }
      },
      selected: {
        possObjectCodes: [],
        regions: [],
        departments: [],
        complexes: []
        // railObjects: {}
      },
      show: false,
      selectedRailObjects: {},
      selectedPreset: 0
    }
  },
  beforeCreate: function () {
    subscribers = []
    filteredRailObjects = []
    railObjectsByOperationModeId = {}
    railObjectsByMonitorStatusId = {}
  },
  created: function () {
    this.railObjects = RailObjectService.getRailObjects()
    this.regions = RegionService.getRegions()
    this.departments = DepartmentService.getDepartments()
    this.complexes = ComplexService.getComplexes()
    this.possObjectCodes = PossObjectCodeService.getPossObjectCodes()
    this.dashboardPresets = DashboardPresetService.getDashboardPresets()

    this.possObjectCodes.forEach((possObjectCode) => {
      possObjectCode.label = possObjectCode.ObjectDescription
      possObjectCode.type = 'possObjectCode'
      possObjectCode.selected = true
    })

    this.regions.forEach((region) => {
      region.label = region.Name
      region.type = 'region'
      region.selected = true
    })

    this.departments.forEach((department) => {
      department.label = department.Name
      department.type = 'department'
      department.selected = true
    })

    this.complexes.forEach((complex) => {
      complex.label = complex.Name
      complex.type = 'complex'
      complex.selected = true
    })

    this.selected.regions = this.regions.map(r => r.RegionId)
    this.selected.departments = this.departments.map(d => d.DepartmentId)
    this.selected.complexes = this.complexes.map(c => c.ComplexId)
    this.selected.possObjectCodes = this.possObjectCodes.map(p => p.Id)
    // this.selected.railObjects = this.railObjects.map(r => r.RailObjectId);

    this.railObjects.forEach((railObject) => {
      railObjectsById[railObject.RailObjectId] = railObject

      railObjectsByOperationModeId[railObject.OperationModeId] = railObjectsByOperationModeId[railObject.OperationModeId] || []
      railObjectsByOperationModeId[railObject.OperationModeId].push(railObject)

      railObjectsByMonitorStatusId[railObject.MonitorStatusId] = railObjectsByMonitorStatusId[railObject.MonitorStatusId] || []
      if (railObject.OperationModeId !== 5) {
        railObjectsByMonitorStatusId[railObject.MonitorStatusId].push(railObject)
      }
    })
  },
  mounted: function () {
    M.FormSelect.init(document.querySelector('select'), {})
  },
  methods: {
    subscribe: function (fn) {
      subscribers.push(fn)
      fn(filteredRailObjects)
    },
    unsubscribe: function (fn) {
      var index = subscribers.indexOf(fn)
      if (index >= 0) {
        subscribers.splice(index, 1)
      } else {
        throw new Error('not found')
      }
    },
    broadcast: function () {
      subscribers.forEach((subscriber) => {
        subscriber(filteredRailObjects)
      })
    },
    filterPresetRailObjects: function () {
      this.selectedRailObjects = {}
      var result = []

      var selectedRegionsById = {}
      this.selected.regions.forEach((regionId) => {
        selectedRegionsById[regionId] = true
      })
      var selectedDepartmentsById = {}
      this.selected.departments.forEach((departmentId) => {
        selectedDepartmentsById[departmentId] = true
      })
      var selectedComplexesById = {}
      this.selected.complexes.forEach((complexId) => {
        selectedComplexesById[complexId] = true
      })
      var selectedPossObjectCodesById = {}
      this.selected.departments.forEach((possObjectCodesId) => {
        selectedPossObjectCodesById[possObjectCodesId] = true
      })

      var baseRailObjects = []
      if (this.statusSelector.operationModeStatus.maintenance) {
        baseRailObjects = baseRailObjects.concat(railObjectsByOperationModeId[5])
      }

      if (this.statusSelector.operationModeStatus.normal) {
        if (this.statusSelector.monitorStatus.unknown) {
          baseRailObjects = baseRailObjects.concat(railObjectsByMonitorStatusId[0])
        }

        if (this.statusSelector.monitorStatus.normal) {
          baseRailObjects = baseRailObjects.concat(railObjectsByMonitorStatusId[1])
        }

        if (this.statusSelector.monitorStatus.warning) {
          baseRailObjects = baseRailObjects.concat(railObjectsByMonitorStatusId[2])
        }

        if (this.statusSelector.monitorStatus.error) {
          baseRailObjects = baseRailObjects.concat(railObjectsByMonitorStatusId[3])
        }
      }

      baseRailObjects.forEach((railObject) => {
        if (!selectedRegionsById[railObject.RegionId]) {
          return
        }

        if (!selectedDepartmentsById[railObject.DepartmentId]) {
          return
        }

        if (!selectedComplexesById[railObject.ComplexId]) {
          return
        }

        if (!selectedPossObjectCodesById[railObject.PossObjectCodeId]) {
          return
        }

        this.selectedRailObjects[railObject.RailObjectId] = true
        result.push(railObject)
      })
      return result
    },
    publishRailObjectFiltering: function () {
      this.show = false
      filteredRailObjects = this.filterPresetRailObjects()
      this.broadcast()
    },
    railObjectColor: function (railObject) {
      switch (UtilitiesService.railObjectClass(railObject)) {
        case 'maintenance':
          return 'blue'
        case 'normal':
          return 'green'
        case 'warning':
          return 'orange'
        case 'error':
          return 'red'
        case 'unknown':
          return 'grey'
      }
    },
    changed2 (item) {
      switch (item.type) {
        case 'possObjectCode':
          if (item.selected) {
            this.selected.possObjectCodes.push(item.Id)
          } else {
            this.selected.possObjectCodes.splice(this.selected.possObjectCodes.indexOf(item.Id), 1)
          }
          break
        case 'region':
          if (item.selected) {
            this.selected.regions.push(item.RegionId)
          } else {
            this.selected.regions.splice(this.selected.regions.indexOf(item.RegionId), 1)
          }
          break
        case 'department':
          if (item.selected) {
            this.selected.departments.push(item.DepartmentId)
          } else {
            this.selected.departments.splice(this.selected.departments.indexOf(item.DepartmentId), 1)
          }
          break
        case 'complex':
          if (item.selected) {
            this.selected.complexes.push(item.ComplexId)
          } else {
            this.selected.complexes.splice(this.selected.complexes.indexOf(item.ComplexId), 1)
          }
          break
      }
      this.publishRailObjectFiltering()
      /* if (item.label !== 'All') return
      let copy = JSON.parse(JSON.stringify(data1))
      copy.forEach(d => !d.disabled && (d.selected = item.selected))
      this.data1 = copy */
    },
    customSelectedText (selected, defaultFn) {
      let hasAll = false
      selected.every((s) => {
        if (s.label === 'All') {
          hasAll = true
          return false
        }
        return true
      })
      if (hasAll) {
        return 'All'
      }
      return defaultFn(selected)
    },
    applyDashboardPreset (item) {
      this.statusSelector.monitorStatus.unknown = true
      this.statusSelector.monitorStatus.normal = true
      this.statusSelector.monitorStatus.warning = true
      this.statusSelector.monitorStatus.error = true
      this.statusSelector.monitorStatus.unknown = true
      this.statusSelector.operationModeStatus.normal = true
      this.statusSelector.operationModeStatus.maintenance = true

      this.selected.regions = this.regions.map(r => r.RegionId)
      this.selected.departments = this.departments.map(d => d.DepartmentId)
      this.selected.complexes = this.complexes.map(c => c.ComplexId)
      this.selected.possObjectCodes = this.possObjectCodes.map(p => p.Id)

      filteredRailObjects = []
      if (item) {
        item.RailObjectIds.forEach((railObjectId) => {
          filteredRailObjects.push(railObjectsById[railObjectId])
        })
      } else {
        filteredRailObjects = this.railObjects
      }

      this.broadcast()
      /* if (item === undefined || item === null || item === 0) {
        resetDashboardPreset()
      } else {
        preset = DashboardPresetService.getDashboardPresetsById(item.Id)
        if (preset.RailObjectIds.length > 0) {
          this.selectedPreset = preset

          this.selectedRailObjects = []
          var regionIds = []
          var regions = []
          var departmentIds = []
          var departments = []
          var complexIds = []
          var complexes = []
          var possobjectcodeIds = []
          var possobjectcodes = []
          var railObjects = []
          this.selectedPreset.RailObjectIds.forEach(function (railObjectid) {
            var railObject = RailObjectService.getRailObjectByRailObjectId(railObjectid)
            if (railObject !== null && railObject !== undefined) {
              railObjects.push(railObject)

              if (regionIds.indexOf(railObject.RegionId) < 0) {
                regionIds.push(railObject.RegionId)
                var region = RegionService.getRegionByRegionId(railObject.RegionId)
                regions.push(region)
              }
              if (departmentIds.indexOf(railObject.DepartmentId) < 0) {
                departmentIds.push(railObject.DepartmentId)
                var department = DepartmentService.getDepartmentByDepartmentId(railObject.DepartmentId)
                departments.push(department)
              }
              if (complexIds.indexOf(railObject.ComplexId) < 0) {
                complexIds.push(railObject.ComplexId)
                var complex = ComplexService.getComplexByComplexId(railObject.ComplexId)
                complexes.push(complex)
              }
              if (possobjectcodeIds.indexOf(railObject.PossObjectCodeId) < 0) {
                possobjectcodeIds.push(railObject.PossObjectCodeId)
                var possObjectCode = PossObjectCodeService.getPossObjectCodeById(railObject.PossObjectCodeId)
                possobjectcodes.push(possObjectCode)
              }
            }
          })

          this.selected.possObjectCodes = possobjectcodes;
          regionsChanged(regions)

          this.railObjects.forEach(function (railObject) {
            railObject.selected = false
          })
          this.selectedRailObjects = railObjects
          if (this.selectedRailObjects.length > 0) {
            this.selectedRailObjects.forEach(function (railObject) {
              railObject.selected = true
            })
          }
          //this.sortedRailObjects = $filter('orderBy')(this.railObjects, ['-selected', 'Name'])
          this.selectedDynamicItems.init()
        } else {
          this.railObjects.forEach(function (railObject) {
            railObject.selected = false
          })
          this.selectedRailObjects = []
          //this.sortedRailObjects = $filter('orderBy')(this.railObjects, ['-selected', 'Name'])
          this.selectedDynamicItems.init()
        }
        this.publishRailObjectFiltering()
      } */
    }
  },
  watch: {
    'statusSelector': {
      handler: function (val, oldVal) {
        this.publishRailObjectFiltering()
      },
      deep: true
    },
    'selected': {
      handler: function (val, oldVal) {
        this.publishRailObjectFiltering()
      },
      deep: true
    },
    'selectedPreset': {
      handler: function (item, oldVal) {
        if (item !== 0) {
          this.selectedPreset = item
          this.applyDashboardPreset(item)
        } else {
          this.selectedPreset = null
          this.applyDashboardPreset()
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.sub-menu-content {
  width:320px;
  position: relative;
  float: left;
  height: calc(100% - 40px);
  padding: 6px;
}

.checkbox-list li {
  display: inline;
}

.input-group__selections {
  height: 30px;
}

.railobject-item {
  width:268px;
  position: relative;
  float:left;
  height:40px;
}

.railobject-name {
  width: 232px;
  position: relative;
  float:left;
}

.railobject-checkbox {
  width: 48px;
  position: relative;
  float:left;
}

.list {
  height: 200px;
  overflow-x: auto;
}

label > .green-text::after {
  background-color: #4CAF50 !important;
}

[type="checkbox"].filled-in:checked+span.green-text:not(.lever):after {
  border: 2px solid #4CAF50;
  background-color: #4CAF50;
}

label > .blue-text::after {
  background-color: #2196F3 !important;
}

[type="checkbox"].filled-in:checked+span.blue-text:not(.lever):after {
  border: 2px solid #2196F3;
  background-color: #2196F3;
}

label > .grey-text::after {
  background-color: #9e9e9e !important;
}

[type="checkbox"].filled-in:checked+span.grey-text:not(.lever):after {
  border: 2px solid #9e9e9e ;
  background-color: #9e9e9e ;
}

label > .orange-text::after {
  background-color: #ff9800 !important;
}

[type="checkbox"].filled-in:checked+span.orange-text:not(.lever):after {
  border: 2px solid #ff9800;
  background-color: #ff9800;
}

label > .red-text::after {
  background-color: #F44336  !important;
}

[type="checkbox"].filled-in:checked+span.red-text:not(.lever):after {
  border: 2px solid #F44336 ;
  background-color: #F44336 ;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.railobject-item > label {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SubMenu.vue